import request from "@/utils/request";

export function getUser(data) {
  return request({
    url: "/student/personal/information",
    method: "post",
    data,
  });
}

export function avatar(data) {
  return request({
    url: "/student/personal/avatar/change",
    method: "post",
    data,
  });
}
export function upload(data) {
  return request({
    url: "/common/file/upload",
    method: "post",
    data,
  });
}
export function myCertificate(data) {
  return request({
    url: "/student/personal/myCertificate",
    method: "post",
    data,
  });
}